// return cookie value or undefined
export function getCookie(name) {

   let pairs = document.cookie.split('; ');

   //This regex pattern is designed to match any of these special characters (., $, ?, *, |, {, }, (, ), [, ], \, /, +, ^) in a string.
   //The g flag ensures that all instances of these characters in the string are found, not just the first one.
   //the format of each pair in pairs is <sanitizedName>=<value> so we are looking for the pair that starts with "<sanitizedName>="
   const startsWith=name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=';

   for (const pair of pairs){
      if (pair.startsWith(startsWith)){
         return decodeURIComponent(pair.replace(startsWith, ''));
      }
   }

   return undefined;
}

/**
 * 
 * @param {string} name 
 * @param {string} value 
 * @param {{path: string, expires: number, domain: *, SameSite: string, Secure: boolean}} options
 */
export function setCookie(name, value, options) {
   options = options || {};

   var expires = options.expires;

   if (typeof expires == 'number' && expires) {
      var d = new Date();
      d.setTime(d.getTime() + expires * 1000);
      expires = options.expires = d;
   }
   if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString();
   }

   value = encodeURIComponent(value);

   var updatedCookie = name + '=' + value;

   for (var propName in options) {
      updatedCookie += '; ' + propName;
      var propValue = options[propName];
      if (propValue !== true) {
         updatedCookie += '=' + propValue;
      }
   }

   document.cookie = updatedCookie;
}

export function deleteCookie(name) {
   setCookie(name, '', {
      expires: -1,
      path: '/',
   });
}
